<template>
    <div>
      <base-header class="pb-6">
        <div class="row align-items-center py-4">
          <div class="col-md-6 mb-3 mb-md-0">
            <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </div>
          <div class="col-md text-md-right">
            <base-button class="rounded-pill" tag="a" type="celcompink" href="/cuenta/nuevo-usuario" v-show="permisos.create">
              Nuevo Usuario
              <i class="fas fa-plus-circle fa-lg text-pink"></i>
            </base-button>
          </div>
        </div>
      </base-header>

      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">

            <div class="card">






              <div class="card-header mb-4">


                <div class="d-flex justify-content-md-between">


                  <div class="" v-if="adminSi.customer.superUserClient">

                          <el-select class="select-danger"
                                    filterable
                                    placeholder="Elegir cliente"
                                    v-model="selects.simple_customer_admin">
                            <el-option v-for="option in selects.customer_admin"
                                      class="select-danger"
                                      :value="option.customerId"
                                      :label="option.name"
                                      :key="option.customerId">
                            </el-option>
                          </el-select>
                  </div>


                  <base-input v-model="keySearch"
                              prepend-icon="fas fa-search"
                              placeholder="Buscar..."
                              class="mb-0">
                  </base-input>
                </div>


              </div>

              <div class="col-12">

                <el-table class="table-responsive table-flush table-striped"
                        header-row-class-name="thead-light"
                        :data="queriedData">

                  <el-table-column label="Nombre"
                                   prop="shortName"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                                {{ row.shortName }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Créditos cuenta"
                                   prop="credits"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                                {{ numberWithCommas(row.remainingSms) }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Activo"
                                   prop="active"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                          <i class="fas"
                              v-bind:class="{'fa-times':(row.active === false), 'fa-check':(row.active === true)}">
                          </i>
                      </template>
                  </el-table-column>

                  <el-table-column label="Administrador"
                                   prop="adminUser"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                          <i class="fas"
                              v-bind:class="{'fa-times':(row.adminUser === false), 'fa-check':(row.adminUser === true)}">
                          </i>
                      </template>
                  </el-table-column>

                  <el-table-column label="Acción" min-width="150px">
                      <div slot-scope="{row}" class="table-actions">
                        <el-tooltip content="Editar" placement="top">
                          <a href="#!" @click.prevent="onEditUser(row)" class="table-action table-action-edit" data-toggle="tooltip" data-original-title="Editar lista" v-show="permisos.modify">
                            <i class="fas fa-edit"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip content="Eliminar" placement="top">
                          <a href="#!" @click.prevent="onDeleteUser(row)" class="table-action table-action-delete" data-toggle="tooltip"
                            data-original-title="Eliminar usuario" v-show="permisos.destroy">
                            <i class="fas fa-trash"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip content="Permisos" placement="top">
                          <a href="#!" @click.prevent="onPermissionsUser(row)" class="table-action" data-toggle="tooltip"
                            data-original-title="Permisos" v-show="permisos.modify">
                            <i class="fas fa-user-check"></i>
                          </a>
                        </el-tooltip>

                        <el-tooltip content="Login" placement="top">
                          <a href="#!" @click.prevent="login_sub_user(row)" class="table-action" data-toggle="tooltip"
                            data-original-title="Login">
                            <i class="fas fa-sign-in-alt"></i>
                          </a>
                        </el-tooltip>
                      </div>
                  </el-table-column>


                </el-table>

              </div>

              <div
                slot="footer"
                class="col-12 mt-4 d-flex justify-content-around justify-content-md-between flex-wrap mb-4 align-items-center"
              >
                  <div class="">
                    <small class="card-category">
                      Mostrando {{ from + 1 }} de {{ to }}  -  {{ total }} entradas

                      <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                      </span>
                    </small>

                  </div>

                  <div class="d-flex align-items-center flex-md-row flex-column">

                    <el-select class="select-primary pagination-select mb-3 mb-md-0 mr-3"
                                v-model="pagination.perPage"
                                placeholder="Per page" >
                      <el-option class="select-primary"
                                  v-for="item in pagination.perPageOptions"
                                  :key="item"
                                  :label="item"
                                  :value="item" >
                      </el-option>
                    </el-select>
                    <base-pagination
                      class="pagination-no-border mb-0"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="total"
                    >
                    </base-pagination>

                  </div>

              </div>
            </div>

          </div>
        </div>

        <div>
          <modal :show.sync="modals.advertenciaSingle"
              gradient="danger"
              modal-classes="modal-danger modal-dialog-centered">
            <h6 slot="header" class="modal-title" id="modal-title-notification">Borrar usuario</h6>

            <div class="text-center">
                <i class="fas fa-exclamation-circle ni-3x mb-3"></i>
                <p class="mb-0">Estás a punto de eliminar este usuario.</p>
                <span>{{ dataUser.shortName }}</span>
            </div>

            <template slot="footer">
                <base-button type="white text-danger"
                              @click="borrarUsuario(dataUser)">
                    Borrar
                </base-button>
                <base-button type="link"
                              class="ml-auto text-white"
                              @click="modals.advertenciaSingle = false">
                    Cerrar
                </base-button>
            </template>
          </modal>

          <modal :show.sync="modals.permisosUser" class="modal-permisos">
            <h6 slot="header" class="modal-title" id="modal-title-default">Permisos de: {{ dataUser.shortName }} </h6>


<div class="row">
                 <div label="Menu" class="col-sm-3">
                     Seleccionar Todo
                </div>
                <div label="Ver" class="col-sm-2">
                              <base-checkbox class="mb-3" v-model="retrieveAll" />
                </div>
                <div label="Crear" class="col-sm-2">
                              <base-checkbox class="mb-3" v-model="createsAll" />
                </div>

                <div label="Modificar" class="col-sm-2">
                              <base-checkbox class="mb-3" v-model="modifyAll" />
                </div>

                <div label="Modificar" class="col-sm-2">
                              <base-checkbox class="mb-3" v-model="destroyAll" />
                </div>

</div>


            <el-table class="table-responsive table-flush"
                      header-row-class-name="thead-light"
                      :data="permisosUsuario">
                <el-table-column label="Menú"
                                prop="view"
                                min-width="140px"
                                sortable>
                  <template v-slot="{row}">
                            {{ setearPermisos(row.applicationMenu.view) }}
                  </template>
                </el-table-column>

                <el-table-column label="Ver"
                                min-width="100px"
                                prop="retrieve"
                                sortable>
                    <template v-slot="{row}">
                              <base-checkbox class="mb-3" v-model="row.retrieve" />
                    </template>
                </el-table-column>

                <el-table-column label="Crear"
                                min-width="100px"
                                prop="creates"
                                sortable>
                    <template v-slot="{row}">
                              <base-checkbox class="mb-3" v-model="row.creates" />
                    </template>
                </el-table-column>

                <el-table-column label="Modificar"
                                min-width="130px"
                                prop="modify"
                                sortable>
                    <template v-slot="{row}">
                              <base-checkbox class="mb-3" v-model="row.modify" />
                    </template>
                </el-table-column>

                <el-table-column label="Borrar"
                                min-width="120px"
                                prop="destroy"
                                sortable>
                    <template v-slot="{row}">
                              <base-checkbox class="mb-3" v-model="row.destroy" />
                    </template>
                </el-table-column>

            </el-table>

            <template slot="footer">
                <base-button type="celcomblue"
                             @click="onEditUserPermission(dataUser)">
                             Guardar cambios
                </base-button>
                <base-button outline
                             type="celcomblue"
                             class="ml-auto"
                             @click="modals.permisosUser = false">Cerrar
                </base-button>
            </template>
          </modal>

          <modal :show.sync="modals.editarUser">
            <h6 slot="header" class="modal-title" id="modal-title-default">Editar perfil de: {{ dataUser.shortName }} </h6>

            <form>
              <h6 class="heading-small text-muted mb-4">Información de Usuario</h6>

              <div>
                <div class="px-lg-4">


                  <div class="row" v-if="typeof dataUser.customer!=='undefined' && adminSi.customer.superUserClient">
                    <div class="col-lg-12">
                      <label>Activar Envios SMS</label>
                      <base-checkbox class="mb-3" v-model="dataUser.customer.sendActive" />
                    </div>
                  </div>


                  <div class="row" v-if="typeof dataUser.customer!=='undefined' && adminSi.customer.superUserClient">
                    <div class="col-lg-12">
                      <label>Activar Carga Inteligente</label>
                      <base-checkbox class="mb-3" v-model="dataUser.customer.uploadActive" />
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        type="text"
                        label="Nombre Corto"
                        v-model="dataUser.shortName"
                      >
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        type="email"
                        label="Correo / Login"
                        v-model="dataUser.email"
                      >
                      </base-input>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        type="text"
                        label="Nombre"
                        v-model="dataUser.name"
                      >
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        type="text"
                        label="Apellido"
                        v-model="dataUser.lastName"
                      >
                      </base-input>
                    </div>
                  </div>


                    <div class="row">






                 <!-- <div class="col-lg-6" v-if="typeof dataUser.customer!=='undefined'">
                      <base-input
                        type="text"
                        label="RUT"
                        v-model="dataUser.customer.rut" />
                    </div>
                    <div class="col-lg-6" v-if="typeof dataUser.customer!=='undefined'">
                      <base-input
                        type="text"
                        label="Direccion"
                        v-model="dataUser.customer.adress"/>
                    </div>-->

                    <div class="col-lg-5">
                        <!-- <base-input
                          :type="type"
                          label="Contraseña"
                          v-model="dataUser.password"
                          
                        /> -->

                        <base-input
                          v-bind:type="showPassword ? 'text' : 'password'" 
                          label="Contraseña"
                          v-model="dataUser.password"
                        />
                    </div>


                    <div class="col-lg-5">
                      <base-input
                        v-bind:type="showPassword ? 'text' : 'password'" 
                        label="Verificar Contraseña"
                        v-model="dataUser.password"/>
                    </div>
                    <div class="col-lg-1">
                      <p>&nbsp;</p>
                      <span class="mr-auto" @click="showPassword = !showPassword">
                        <i class="fa" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i>
                      </span> 
                    </div>











                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        type="password"
                        label="Contraseña"
                        v-model="dataUser.password"/>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        type="password"
                        label="Verificar Contraseña"
                        v-model="dataUser.password"/>
                    </div>
                  </div>
                </div>
                <hr class="my-4">

                <div class="px-lg-4">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label d-block">
                        País
                      </label>
                      <el-select class="select-danger"
                        placeholder="Elegir País"
                        v-model="selects.simple">
                        <el-option v-for="option in selects.paises"
                                  class="select-danger"
                                  :value="option.name"
                                  :label="option.name"
                                  :key="option.name">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label d-block">
                        Idioma
                      </label>
                      <el-select class="select-danger"
                        placeholder="Elegir Idioma"
                        v-model="selects.simpleIdioma">
                        <el-option v-for="option in selects.idioma"
                                  class="select-danger"
                                  :value="option.name"
                                  :label="option.name"
                                  :key="option.name">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="col-md-4">
                      <label class="form-control-label d-block">
                        Zona Horaria
                      </label>
                      <el-select class="select-danger"
                        placeholder="Elegir Zona Horaria"
                        v-model="selects.simpleZona">
                        <el-option v-for="option in selects.zonaHoraria"
                                  class="select-danger"
                                  :value="option.name"
                                  :label="option.name"
                                  :key="option.name">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="adminSi.adminUser==true">
                <hr class="mt-5 mb-4">

                <h6 class="heading-small text-muted mb-4">Límite SMS</h6>

                <base-alert type="celcompink" class="mb-4">
                    Los créditos total disponibles: <strong>{{ numberWithCommas((dataUser.customer != null) ? dataUser.customer.remainingSms : 0) }}</strong>
                </base-alert>

                <div class="px-lg-4">

                  <div class="row">
                    <div class="col-md-6 mb-md-5">
                      <base-radio name="checked" v-model="radio.radio1">
                        Límite propio
                        <el-tooltip content="Consumir créditos de tu límite propio" placement="top">
                          <i class="btn-tooltip fas fa-question-circle"></i>
                        </el-tooltip>
                      </base-radio>

                    </div>

                    <div class="col-md-6">
                      <base-input type="text"
                                  class="mb-0"
                                  :disabled="radio.radio1=='unchecked'"
                                  v-model="dataUser.remainingSms" />
                      <small>Restantes</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <base-radio name="unchecked" class="mb-3" v-model="radio.radio1">
                        Límite cuenta master
                      </base-radio>
                    </div>
                  </div>
                </div>

                <div class="pl-lg-4 text-right">
                  <base-button type="celcomblue" @click="editarInfoCuenta">Guardar</base-button>
                </div>
              </div>

            </form>

          </modal>

        </div>


      </div>

  </div>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui'
  import { BasePagination, Modal, Dialog } from '@/components';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload';

  import moment from 'moment';
  import XLSX from 'xlsx';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';
  import swal from 'sweetalert2';

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora,search_data, onPermissionsUser,getUserAdmin,
  setUserSub } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    mixins: [clientPaginationMixin],
    components: {
      DropzoneFileUpload,
      BasePagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      Modal,
      Dialog
    },
    data() {
      return {

	showPassword: false,
        retrieveAll:false,
        createsAll:false,
        modifyAll:false,
        destroyAll:false,



        keySearch:"",
        currentPage: 1,
        tableData: [],
        permisosUsuario: [],
        selectedRows: [],
        tabContact: false,
        dataUser: {},
        adminSi: getUser(),
        modals: {
          formSingle: false,
          advertenciaSingle: false,
          permisosUser: false,
          editarUser: false
        },
        fileSingle: [],
        checkboxes: {
            active: true,
        },
        selects: {
        customer_admin:getUserAdmin(),
        simple_customer_admin:"",
        simple: '',
        paises: [],
        simpleIdioma: '',
        idioma: [],
        simpleZona: '',
        zonaHoraria: []
      },
        radio: {
          radio1: "checked",
        },
        permisos: {
          create: onPermissionsUser('users.xhtml', 'create'),
          modify: onPermissionsUser('users.xhtml', 'modify'),
          destroy: onPermissionsUser('users.xhtml', 'destroy'),
        }
      };
    },
    methods: {




      setearPermisos(val){
        var permiso = "";

          switch (val) {
            case 'credits_transaction.xhtml':
                permiso = "Compra Creditos";
              break;

            case 'shippment.xhtml':
                permiso = "Envios";
              break;

            case 'report.xhtml':
                permiso = "Reportes";
              break;

            case 'contacts.xhtml':
                permiso = "Contactos";
              break;

            case 'drafts.xhtml':
                permiso = "Plantillas";
              break;

            case 'my_data.xhtml':
                permiso = "Perfil";
              break;

            case 'users.xhtml':
                permiso = "Usuarios";
              break;

            case 'shippment_abort.xhtml':
                permiso = "Envios Programados";
              break;

            case 'video.xhtml':
                permiso = "Videos";
              break;

            case 'blacklist.xhtml':
                permiso = "BlackList";
              break;

            case 'report_mo.xhtml':
                permiso = "Reporte MO";
              break;

            case 'manual.xhtml':
                permiso = "Manual";
              break;


            default:
                permiso = val;
              break;
          }

        return permiso;
      },


    obtenerInfoCuenta() {

    let self = this;
    let user = getUser();


    var cusActual =   user.customer;


    let js = {
      "time_expired":horaAhora(),
      "customer":encodeURIComponent(JSON.stringify(cusActual))
    }

    var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

    Vue.axios.post(Config.url_service+Config.costumer_user_available, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    })
      .then(function (response) {

          if (response.data.response === "200") {

            response.data.data.forEach(function(element) {
              if(element.customerUserId === user.customerUserId) {

                  self.selects.paises.push({'name':element.customer.country.name})
                  self.selects.zonaHoraria.push({'name':element.customer.country.gmt_timezone_name+"|"+element.customer.country.gmt_timezone_interval})
                  self.selects.simple = element.customer.country.name
                  self.selects.simpleZona = element.customer.country.gmt_timezone_name+"|"+element.customer.country.gmt_timezone_interval
                  self.selects.simpleIdioma = element.customer.language.name

                  self.adminSi = element;
              }
            })

          } else {
            console.log("No se encontró usuario");
            alert("No se encontró usuario");
          }


      })
      .catch(function (error) {
          console.log("No se encontró usuario",error);
          alert("No se encontró usuario");

      });

    },


    login_sub_user(row){

        setUserSub(row);

      swal({
        title: 'Inicio de Sesion con '+row.shortName,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success',
        type: 'success',
      }).then(function() {
       window.location.href="/cuenta/usuarios"
      })

    },

     obtenerUsuarios() {

      this.$loading.show()   //delay default is 300ms

      let self = this;
      let user = getUser();



    var cusActual =   user.customer;

    this.selects.customer_admin.forEach(function(element) {
      if(element.customerId == self.selects.simple_customer_admin ){
        cusActual = element;
      }
    })

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(cusActual))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.costumer_user_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {

            if (response.data.response === "200") {
              console.log(response.data.data)
              self.tableData = response.data.data;

            } else {
              console.log("No se encontraron usuarios");
              swal({
                title: 'No se encontraron usuarios',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron usuarios",error);
            swal({
                title: 'No se encontraron usuarios',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
            })
            self.$loading.hide();
        });

      },
      onDeleteUser(row) {

        let self = this;
        let modals = modals;

        self.dataUser = row;
        self.modals.advertenciaSingle = true;

      },
      borrarUsuario(dataUser) {

        this.$loading.show()

        let self = this;
        let user = getUser();

        let js = {
          "time_expired":horaAhora(),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
          "customer_user":encodeURIComponent(JSON.stringify(this.dataUser))
        }

        console.log(js);

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.customer_user_detele, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);

                self.tableData = response.data.data;
                self.modals.advertenciaSingle = false;

              } else {
                console.log("No se pudo borrar usuario");
                swal({
                  title: 'No se pudo borrar usuario',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })
          .catch(function (error) {
              console.log("No se pudo borrar usuario",error);
              swal({
                title: 'No se pudo borrar usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

          self.$loading.hide()

      },
      onPermissionsUser(row) {

        let self = this;
        let modals = modals;

        self.dataUser = row;
        self.modals.permisosUser = true;

        this.$loading.show()

        let user = getUser();

        let js = {
          "time_expired":horaAhora(),
          "customer_user":encodeURIComponent(JSON.stringify(this.dataUser))
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.customer_user_access, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);

                self.permisosUsuario = response.data.data;

              } else {
                console.log("No se pudo obtener permisos");
                swal({
                  title: 'No se pudo obtener permisos',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })
          .catch(function (error) {
              console.log("No se pudo obtener permisos",error);
              swal({
                title: 'No se pudo obtener permisos',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

          self.$loading.hide()

      },
      onEditUserPermission(dataUser) {
        let self = this;
        let modals = modals;

        this.$loading.show()

        let user = getUser();

        let js = {
          "time_expired":horaAhora(),
          "authorized_menus":encodeURIComponent(JSON.stringify(this.permisosUsuario)),
          "customer_user":encodeURIComponent(JSON.stringify(this.dataUser))
        }

        console.log(js);

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.customer_user_access_edit, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);

                self.modals.permisosUser = false;
                swal({
                  title: '¡Permisos editados!',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success',
                  type: 'success',
                })

              } else {
                console.log("No se pudo editar permisos");
                swal({
                  title: 'No se pudo editar permisos',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })
          .catch(function (error) {
              console.log("No se pudo editar permisos",error);
              swal({
                title: 'No se pudo editar permisos',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

          self.$loading.hide()
      },
      onEditUser(row) {

        let self = this;
        let modals = modals;

        self.dataUser = row;

        self.selects= {
        customer_admin:getUserAdmin(),
        simple_customer_admin:"",
        simple: '',
        paises: [],
        simpleIdioma: '',
        idioma: [],
        simpleZona: '',
        zonaHoraria: []
      };

        self.selects.paises.push({'name':row.customer.country.name})
        self.selects.zonaHoraria.push({'name':row.customer.country.gmt_timezone_name+"|"+row.customer.country.gmt_timezone_interval})
        self.selects.simple = row.customer.country.name
        self.selects.simpleZona = row.customer.country.gmt_timezone_name+"|"+row.customer.country.gmt_timezone_interval
        self.selects.simpleIdioma = row.customer.language.name
        self.radio.radio1 = (row.smsAdminUser) ? "unchecked" : "checked";

        self.modals.editarUser = true;

      },
      editarInfoCuenta(){

      this.$loading.show()

      let self = this;
      let user = getUser();



      if(this.dataUser.name=="" || this.dataUser.lastName=="" || this.dataUser.email=="" || this.dataUser.password=="" || this.dataUser.shortName=="" || (this.dataUser.remainingSms=="" && self.radio.radio1=="checked")){
         this.$loading.hide()
          swal({
            title: "Error Debe completar todos los campos",
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-danger btn-fill'
          })
          return false;
      }


      var  zonaTime =  self.selects.simpleZona.split("|");
      this.dataUser.customer.country.gmt_timezone_name=zonaTime[0];
      this.dataUser.customer.country.gmt_timezone_interval=zonaTime[1];

      this.dataUser.smsAdminUser = (self.radio.radio1=="unchecked") ? "true":"false"

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(this.dataUser.customer)),
        "customer_user":encodeURIComponent(JSON.stringify(this.dataUser))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.costumer_user_edit, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)
            if (response.data.response === "200") {

              self.dataUser = response.data.data;

              self.dataUser.forEach(function(element) {
                if(element.customerUserId === user.customerUserId) {

                    self.dataUserActual = element;
                    setUser(element);
                }
              })

              self.modals.editarUser = false;

              self.element = response.data.data;
              swal({
                title: '¡Datos editados con éxito!',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success',
                type: 'success',
              })

            } else {
              console.log("No se editó usuario");
              swal({
                title: 'No se editó usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se editó usuario",error);
            swal({
              title: 'No se editó usuario',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'error',
            })

            self.$loading.hide()
        });

      },
        obtenerPaises() {

      let self = this;

      let js = {
        "time_expired":horaAhora(),
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.country_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {

            if (response.data.response === "200") {

              self.selects.paises = response.data.data;
              console.log(response.data.data)


            } else {
              console.log("No se encontraron paises");
              alert("No se encontraron paises");
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron paises",error);
            alert("No se encontraron paises");

            self.$loading.hide()
        });

      },
      obtenerIdiomas() {

      let self = this;

      let js = {
        "time_expired":horaAhora(),
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.language_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {

            if (response.data.response === "200") {

              self.selects.idioma = response.data.data;
              console.log(response.data.data)


            } else {
              console.log("No se encontraron paises");
              alert("No se encontraron paises");
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron paises",error);
            alert("No se encontraron paises");

            self.$loading.hide()
        });

      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD HH:mm:ss');
      },
      numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      onBlurNumber(e) {
        //this.temp = this.dataUser.remainingSms;
        //this.dataUser.remainingSms = this.thousandSeprator(this.dataUser.remainingSms);
      },
      thousandSeprator(amount) {
        if (this.dataUser.remainingSms !== '' || this.dataUser.remainingSms !== undefined || this.dataUser.remainingSms !== 0 || this.dataUser.remainingSms !== '0' || this.dataUser.remainingSms !== null) {
          return this.dataUser.remainingSms.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
            return this.dataUser.remainingSms;
        }
      }
    },
    mounted() {


      this.obtenerUsuarios();
     // this.obtenerPaises();
     // this.obtenerIdiomas();
      this.obtenerInfoCuenta(null);

     if(!onPermissionsUser('users.xhtml', 'view')) {
        swal({
          title: 'No tienes los permisos para acceder a esta página.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          type: 'error',
          }).then(function() {
            window.location.href="/dashboard";
        })

      }
    },
    create() {
      this.$loading.show();
    },
    watch: {

      'keySearch'(newVal){
          if(newVal.toString().length>3){
            this.searchedData = search_data(newVal, this.tableData);
          }else{
            this.searchedData = this.tableData;
          }
      },

      'selects.simple_customer_admin'(newVal){
            this.obtenerUsuarios();
      },


      'retrieveAll'(newVal){
            this.permisosUsuario.forEach(function(element) {
                    element.retrieve = newVal;
              })
      },

      'createsAll'(newVal){
            this.permisosUsuario.forEach(function(element) {
                    element.creates = newVal;
              })
      },

      'modifyAll'(newVal){
            this.permisosUsuario.forEach(function(element) {
                    element.modify = newVal;
              })
      },

      'destroyAll'(newVal){
            this.permisosUsuario.forEach(function(element) {
                    element.destroy = newVal;
              })
      },

    },
    computed: {

    }
  }
</script>

<style>
.modal-secondary .close > span:not(.sr-only) {
  color: #172b4d;
}
.busy-mask {
  z-index: 1051;
}
@media (min-width: 576px) {
  .modal-permisos .modal-dialog {
    max-width: 720px;
    margin: 1.75rem auto;
  }
}
</style>
